import { StrictMode } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Start from "./Components/Start";
import { Layout } from "./layout";
import { ChakraProvider } from "@chakra-ui/react";
import { Foreningen } from "./Components/foreningen";
import { Membership } from "./Components/Membership";
import { Events } from "./Components/Event/events";
import { CompetitionView } from "./Components/Event/CompetitionView";
import { VerifySignup } from "./Components/VerifySignup/VerifySignup";
import { SignupFlow } from "./Components/Event/Signup/SignupFlow";
import { Startlist } from "./Components/Event/Startlista/startlist";
import "./global.css";
import { createRoot } from "react-dom/client";
import { ModifySignupComponent } from "./Components/Event/Signup/Modify/ModifySignupsComponent";
import { SignupVerification } from "./Session/SignupVerification";
import { GlobalProvider } from "./Session/GlobalState";
import theme from "./chakra-theme";
import { PasswordChangeVerification } from "./Session/PasswordChangeVerification";
import { BackendResultsComponent } from "./Components/Event/Results/BackendResults";
import { SponsorsPage } from "./sponsors/sponsors_page";
import { ResultDownloadView } from "./Components/Event/Results/ResultDownloadView";

const containter = document.getElementById("root");
const root = createRoot(containter!);

root.render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      <GlobalProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Start />} />
              <Route path="signup/verify" element={<SignupVerification />} />
              <Route
                path="passwordchange/verify"
                element={<PasswordChangeVerification />}
              />
              <Route path="medlemskap" element={<Membership />}></Route>
              <Route path="tavlingar">
                <Route index element={<Events />} />
                <Route path=":competitionTag">
                  <Route index element={<CompetitionView />} />
                  <Route path="anmalan" element={<SignupFlow />} />
                  <Route path="modify" element={<ModifySignupComponent />} />
                  <Route path="startlista" element={<Startlist />} />
                  <Route
                    path="resultat"
                    element={<BackendResultsComponent />}
                  />
                </Route>
              </Route>
              <Route
                path="sponsorer"
                element={
                  <SponsorsPage />
                }
              ></Route>
              <Route path="foreningen" element={<Foreningen />}></Route>
              <Route path="anmalan-bekrafta" element={<VerifySignup />}></Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </GlobalProvider>
    </ChakraProvider>
  </StrictMode>
);
